import axios from 'axios'
//本机
// export const URLROUTER = "http://123.13.201.253:1182"
export const URLROUTER = "https://kzky.wlysjt.com"
export const ERROK = "0"
export const NOTLOGIN = 301
export const AMOUNT = 10
export const options = {
  param: 'jsonpCallback'
}
// 全局的请求次数和请求间隙
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
// axios.defaults.timeout = 60000;
axios.defaults.baseURL = process.env.BASE_API;
// 添加请求拦截器
axios.interceptors.request.use(config => {
  config.headers = {
    'Content-Type': 'application/json'
    // multipart/form-data
    // text/html
  }
  // let token = localStorage.getItem("tokenInfoToken");
  // if (token != "" && token != 'undefined') {
  //   config.headers.zzit_token = localStorage.getItem("tokenInfoToken");
  // }
  // let formData = new FormData()
  // formData.append('msg', JSON.stringify(config.data))

  // config.data = JSON.stringify(config.data)
  return config;
},
  err => Promise.reject(err)
)
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    localStorage.setItem('tokenInfoToken', response.data.token)
    return Promise.resolve(response)
  },
  error => {
    console.log(error.response);
  /*   if(error.response.data.msgBody.state=="2"){
      localStorage.removeItem("tokenInfoToken");
      Message.error(error.response.data.msgBody.info);
    } */

    
    var config = error.config;
    // 如果config不存在活未设置重试选项，请拒绝
    if (!config || !config.retry) {
      return Promise.reject(error);
    }
    // 设置变量跟踪重复次数
    config._retryCount = config._retryCount || 0;
    // 检查是否已经到达最大重复次数
    if (config._retryCount >= config.retry) {
      // 抛出错误信息
      return Promise.reject(error);
    }
    // 增加请求重复次数
    config._retryCount += 1;
  }
)
export default axios;



// WEBPACK FOOTER //
// ./src/api/config.js